import { useCallback, useEffect, useState } from 'react'

export type Theme = 'light' | 'dark'

const STORAGE_KEY = 'skava-theme'

function currentTheme(): Theme {
  const attribute = document.documentElement.dataset.theme
  return attribute === 'dark' ? 'dark' : 'light'
}

/**
 * Tema disimpan di localStorage dan diterapkan pada elemen html.
 *
 * Nilai awal sudah dipasang oleh skrip kecil di index.html sebelum React
 * memasang, sehingga tidak ada kedipan putih di layar pengguna mode gelap.
 */
export function useTheme(): { theme: Theme; toggle: () => void } {
  const [theme, setTheme] = useState<Theme>(() => (typeof document === 'undefined' ? 'light' : currentTheme()))

  useEffect(() => {
    document.documentElement.dataset.theme = theme
    localStorage.setItem(STORAGE_KEY, theme)
  }, [theme])

  const toggle = useCallback(() => {
    setTheme((current) => (current === 'dark' ? 'light' : 'dark'))
  }, [])

  return { theme, toggle }
}
